/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Number_Should_Be_Less_Than_Or_Equal_To_Max_NumberInputs */



/**
* | output |
* | --- |
* | "The number must be less than or equal to {n}" |
*
* @param {Number_Should_Be_Less_Than_Or_Equal_To_Max_NumberInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const number_should_be_less_than_or_equal_to_max_number = /** @type {((inputs: Number_Should_Be_Less_Than_Or_Equal_To_Max_NumberInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Number_Should_Be_Less_Than_Or_Equal_To_Max_NumberInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`The number must be less than or equal to ${i?.n}`)
	return /** @type {LocalizedString} */ (`Le numéro doit être inferieur ou égale à ${i?.n}`)
});